"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.corsImport = void 0;
const loadjs_1 = __importDefault(require("loadjs"));
function corsImport(src, noCache = false) {
    const bundleId = noCache ? `${src}?t=${Date.now()}` : src;
    (0, loadjs_1.default)([src], bundleId, {
        before(path, scriptEl) {
            scriptEl.crossOrigin = 'anonymous';
            // vite serves content as is and requires `module` type
            if (path.match(/\.tsx?/)) {
                scriptEl.type = 'module';
            }
        },
        numRetries: 6,
    });
    return new Promise((resolve, reject) => {
        const resolvedTyped = resolve;
        loadjs_1.default.ready(bundleId, {
            success: resolvedTyped,
            error: reject,
        });
    });
}
exports.corsImport = corsImport;
//# sourceMappingURL=cors-import.js.map